import { createSelector } from "reselect";
import type {
  LoadingState,
} from "@fas/ui-framework";
import type { State } from "../../pages/AppStoreWrapper";
import {
  ACCOUNT_LIST,
  SAVE_REDIRECT_LOADING,
  GET_REDIRECT_LOADING,
  GET_LINKING_LOADING,
  SAVE_LINKING_LOADING,
  ACCOUNT_MODULES_LOADING,
  GET_PAGE_LOADING,
  SAVE_PAGE_LOADING,
  GET_PAGE_LIST_LOADING,
  GET_ACCOUNT_LOADING,
  SAVE_ACCOUNT_LOADING,
  PAGE_EXPORTING_LOADING,
  PAGE_IMPORTING_LOADING,
  PAGE_CLONING_LOADING,
  HEIGHT_LOADING,
  DOWNLOAD_PAGE_RESOURCES_LOADING,
} from "../../helpers/constants";

export const getIsPageLoading = createSelector(
  (state: State) => state.loading,
  (loading: LoadingState) => loading.get(GET_PAGE_LOADING, false)
);

export const getIsPageListLoading = createSelector(
  (state: State) => state.loading,
  (loading: LoadingState) => loading.get(GET_PAGE_LIST_LOADING, false)
);

export const getIsSavePageLoading = createSelector(
  (state: State): LoadingState => state.loading,
  (loading: LoadingState): boolean => loading.get(SAVE_PAGE_LOADING, false)
);

export const getIsAccountLoading = createSelector(
  (state: State) => state.loading,
  (loading: LoadingState) => loading.get(GET_ACCOUNT_LOADING, false)
);

export const getIsSaveAccountLoading = createSelector(
  (state: State) => state.loading,
  (loading: LoadingState) => loading.get(SAVE_ACCOUNT_LOADING, false)
);

export const getIsRedirectLoading = createSelector(
  (state: State) => state.loading,
  (loading: LoadingState) => loading.get(GET_REDIRECT_LOADING, false)
);

export const getIsSaveRedirectLoading = createSelector(
  (state: State) => state.loading,
  (loading: LoadingState) => loading.get(SAVE_REDIRECT_LOADING, false)
);

export const getIsPageExporting = createSelector(
  (state: State) => state.loading,
  (loading: LoadingState) => loading.get(PAGE_EXPORTING_LOADING, false)
);

export const getIsPageImporting = createSelector(
  (state: State) => state.loading,
  (loading: LoadingState) => loading.get(PAGE_IMPORTING_LOADING, false)
);

export const getIsClonePageLoading = createSelector(
  (state: State) => state.loading,
  (loading: LoadingState) => loading.get(PAGE_CLONING_LOADING, false)
);

export const getIsLinkedItemSavingLoading = createSelector(
  (state: State) => state.loading,
  (loading: LoadingState) => loading.get(SAVE_LINKING_LOADING, false)
);

export const getIsLinkedItemLoading = createSelector(
  (state: State) => state.loading,
  (loading: LoadingState) => loading.get(GET_LINKING_LOADING, false)
);

export const getIsLinkedItemHeightLoading = createSelector(
  (state: State) => state.loading,
  (loading: LoadingState) => loading.get(HEIGHT_LOADING, false)
);

export const getIsAccountModulesLoading = createSelector(
  (state: State) => state.loading,
  (loading: LoadingState) => loading.get(ACCOUNT_MODULES_LOADING, false)
);

export const getAccountsListLoading = createSelector(
  (state: State) => state.loading,
  (loading: LoadingState) => loading.get(ACCOUNT_LIST, false)
);

export const getIsResourceDownloading = createSelector(
  (state: State) => state.loading,
  (loading: LoadingState) => loading.get(DOWNLOAD_PAGE_RESOURCES_LOADING, false)
);
